


















import { Vue, Component, Prop } from "vue-property-decorator";
import { BackgroundModule } from "@/modules/BackgroundModule";
import { FrameStore } from "@/modules/base";
import { EsoMilkyWayLayer } from '@hscmap/stellar-globe'
import { Layer2Component } from '@/stellar-globe-components';

@Component({
  components: {
    EsoMilkyWayLayer: Layer2Component(EsoMilkyWayLayer),
  },
})
export default class extends Vue {
  @Prop({ required: true })
  frameStore!: FrameStore<typeof BackgroundModule>
}
